const layout = {
  container: {
    sm: 600,
    md: 720,
    lg: 960,
    xl: 960
  },
  breakpoints: {
    xs: 0,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1280
  }
}

export const getBreakpointsInPixels = () => {
  const breakpointsWithPixels = {}

  for (const size in layout.breakpoints) {
    breakpointsWithPixels[size] = layout.breakpoints[size] + 'px'
  }

  return breakpointsWithPixels
}

export default layout
